import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { MediaPlayerBaseComponent } from '../media-player.component';
import { BlueBillywigPlayerStateIconsEnum } from '../media-player.type';
import { styles, tag } from './audio-inline.styles';

@customElement(tag)
export class MediaPlayerAudioInlineComponent extends MediaPlayerBaseComponent {
  static override styles = styles;

  override render() {
    const classes = {
      playing: this.playing,
      paused: this.paused,
      idle: this.idle,
      button: true,
    };

    return html`
      <div class="player-container" aria-hidden="true"></div>
      <button
        aria-label="${`audio player inline with status ${this.currentPlayerState}` ||
        'loader'}"
        @click="${this.togglePlayState}"
        class=${classMap(classes)}
        type="button"
        data-test="${tag}-button"
      >
        ${unsafeHTML(
          `<a-icon class="icon" name=${
            BlueBillywigPlayerStateIconsEnum[
              this.currentPlayerState || 'loader'
            ]
          }></a-icon>`,
        )}
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-audio-inline-player': MediaPlayerAudioInlineComponent;
  }
}
